import {
  Box,
  Checkbox,
  FormControl,
  FormControlLabel,
  IconButton,
  InputAdornment,
  InputLabel,
  OutlinedInput,
  Select,
  TextField,
  Typography,
} from "@material-ui/core";
import React, { useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import HomeIcon from "@material-ui/icons/Home";
import AddIcon from "@material-ui/icons/Add";
import SearchIcon from "@material-ui/icons/Search";

const useStyles = makeStyles({
  quoteHeading: {
    display: "flex",
    justifyContent: "space-between",
    background: "#DEECFC",
    padding: "10px 20px",
    borderRadius: "10px",
    margin: "10px 0",
  },
  quoteContent: {
    padding: "10px 0px",
    borderRadius: "5px",
  },
  title: {
    paddingBottom: "0px",
  },
  requestQuoteTitle: {
    display: "flex",
    alignItems: "center",
    columnGap: "5px",
  },
  formControl: {
    minWidth: 300,
  },
  selectEmpty: {},
  quoteContainer: {
    display: "flex",
    gap: "20px",
    flexWrap: "wrap",
  },
  requestQuote1Submit: {
    width: "160px",
    height: "45px",
    marginInlineEnd: "10px",
    background: "#BE1E2D",
    color: "#fff",
    marginTop: "20px",
    fontWeight: "600",
  },
});

const ProjectDetails = () => {
  const classes = useStyles();
  const [state, setState] = React.useState({
    Food: "",
    fullLoad: "",
    truckType: "",
    make: "",
    lessLoad: "",
    top: "",
    side: "",
    name: "hai",
  });
  const [productDetalis, setProductDetalis] = useState([1, 1]);

  const handleChange = (event) => {
    const name = event.target.name;
    setState({
      ...state,
      [name]: event.target.value,
    });
  };
  const hanldeIncrementDetails = () => {
    setProductDetalis((prv) => [...prv, 1]);
  };
  return (
    <Box>
      <Box
        style={{
          display: "flex",
          alignItems: "center",
          columnGap: "10px",
          padding: "15px 0",
        }}
      >
        <Typography variant="span">
          <HomeIcon />
        </Typography>
        <Typography variant="h6">Product Details </Typography>
      </Box>
      <Box className="quoteHeading2">
        <Box className="firstHeading">
          <Typography variant="h5">Product</Typography>
        </Box>
        <Box className="firstHeading2">
          <Typography variant="h5">Product Classification</Typography>
        </Box>
        <Box className="firstHeading3">
          <Typography variant="h5">Qty</Typography>
        </Box>
        <Box className="firstHeading4">
          <Typography variant="h5">Weight</Typography>
        </Box>
        <Box className="firstHeading5">
          <Typography variant="h5">Size</Typography>
        </Box>
        <Box className="firstHeading6">
          <Typography variant="h5">MSDS</Typography>
        </Box>
        <Box className="firstHeading7">
          <Typography variant="h5">Packing</Typography>
        </Box>
        <Box className="firstHeading8">
          <Typography variant="h5">Package Type</Typography>
        </Box>
        <Box className="firstHeading9">
          <Typography variant="h5">Gross Value</Typography>
        </Box>
        <Box className="firstHeading10">
          <Typography variant="span">
            <AddIcon onClick={hanldeIncrementDetails} />
          </Typography>
        </Box>
      </Box>
      {productDetalis.map((_, i) => (
        <Box className="requestQuoteInputParent" key={i}>
          <Box className="requestQuoteInput">
            <Box className="input1">
              <FormControl
                className={(classes.margin, classes.textField)}
                variant="outlined"
              >
                <InputLabel htmlFor="outlined-adornment-password">
                  Enter commodity type
                </InputLabel>
                <OutlinedInput
                  id="outlined-adornment-password"
                  type={"text"}
                  value={""}
                  endAdornment={
                    <InputAdornment position="end">
                      <IconButton
                        aria-label="toggle password visibility"
                        edge="end"
                      >
                        <SearchIcon />
                      </IconButton>
                    </InputAdornment>
                  }
                  labelWidth={90}
                />
              </FormControl>
            </Box>
            <Box className="input2">
              <FormControl
                className={(classes.margin, classes.textField)}
                variant="outlined"
              >
                <TextField
                  id="outlined-basic"
                  label="Chemicals"
                  variant="outlined"
                />
              </FormControl>
            </Box>
            <Box className="input3">
              <FormControl
                className={(classes.margin, classes.textField)}
                variant="outlined"
              >
                <TextField id="outlined-basic" label="4" variant="outlined" />
              </FormControl>
            </Box>
            <Box className="input4">
              <FormControl
                className={(classes.margin, classes.textField)}
                variant="outlined"
              >
                <TextField
                  id="outlined-basic"
                  label="500 kgs"
                  variant="outlined"
                />
              </FormControl>
            </Box>
            <Box className="input5">
              <FormControl
                className={(classes.margin, classes.textField)}
                variant="outlined"
              >
                <TextField id="outlined-basic" label="L" variant="outlined" />
              </FormControl>
            </Box>
            <Box className="input6">
              <FormControl
                className={(classes.margin, classes.textField)}
                variant="outlined"
              >
                <TextField id="outlined-basic" label="W" variant="outlined" />
              </FormControl>
            </Box>
            <Box className="input7">
              <FormControl
                className={(classes.margin, classes.textField)}
                variant="outlined"
              >
                <TextField id="outlined-basic" label="W" variant="outlined" />
              </FormControl>
            </Box>
            <Box className="input8">
              <FormControl
                className={(classes.margin, classes.textField)}
                variant="outlined"
              >
                <InputLabel htmlFor="outlined-age-native-simple">
                  Inch
                </InputLabel>
                <Select
                  native
                  value={state.lessLoad}
                  onChange={handleChange}
                  label="Inch"
                  inputProps={{
                    name: "Inch",
                    id: "outlined-age-native-simple",
                  }}
                >
                  <option aria-label="None" value="" />
                  <option value={"Less Truck Load (LTL)"}>Inch</option>
                  <option value={20}>Twenty</option>
                  <option value={30}>Thirty</option>
                </Select>
              </FormControl>
            </Box>
            <Box className="input9">
              <FormControl
                className={(classes.margin, classes.textField)}
                variant="outlined"
              >
                <TextField id="outlined-basic" label="" variant="outlined" />
              </FormControl>
            </Box>
            <Box className="input10">
              <FormControl
                className={(classes.margin, classes.textField)}
                variant="outlined"
              >
                <InputLabel htmlFor="outlined-age-native-simple">
                  Packed
                </InputLabel>
                <Select
                  native
                  value={state.lessLoad}
                  onChange={handleChange}
                  label="Inch"
                  inputProps={{
                    name: "Inch",
                    id: "outlined-age-native-simple",
                  }}
                >
                  <option aria-label="None" value="" />
                  <option value={"Less Truck Load (LTL)"}>Inch</option>
                  <option value={20}>Twenty</option>
                  <option value={30}>Thirty</option>
                </Select>
              </FormControl>
            </Box>
            <Box className="input11">
              <FormControl
                className={(classes.margin, classes.textField)}
                variant="outlined"
              >
                <TextField
                  id="outlined-basic"
                  label="Pallets"
                  variant="outlined"
                />
              </FormControl>
            </Box>
            <Box className="input12">
              <FormControl
                className={(classes.margin, classes.textField)}
                variant="outlined"
              >
                <TextField
                  id="outlined-basic"
                  label="AED 100,000"
                  variant="outlined"
                />
              </FormControl>
            </Box>
            <Box className="DetailscheckBox">
              <FormControlLabel
                control={
                  <Checkbox
                    onChange={handleChange}
                    name="checkedB"
                    color="primary"
                  />
                }
                label="Stackable"
              />
            </Box>
          </Box>
        </Box>
      ))}
    </Box>
  );
};

export default ProjectDetails;
